import React from "react";
import styles from "./thankyou.module.css";
import { useParams } from "react-router-dom";

export const ThankYou = () => {
  const workshops = {
    "my-body-is-mine": {
      name: "My Body Is Mine",
      link: "https://chat.whatsapp.com/J64VmUI07Jq7BnJsDIyWRZ",
    },
    "positive-puberty-girls": {
      name: "Positive Puberty Girls",
      link: "https://chat.whatsapp.com/GrJldcbFA3C7Z9CAQK4Cp1",
    },
    "positive-puberty-boys": {
      name: "Positive Puberty Boys",
      link: "https://chat.whatsapp.com/FsiUXkTFylQIDCKfgqjGkM",
    },
    "puberty-and-beyond": {
      name: "Puberty & Beyond",
      link: " https://chat.whatsapp.com/G7QtOV3RuNgCMDDqTwWqHY",
    },
    "sexual-literacy": {
      name: "Sexual Literacy",
      link: "https://chat.whatsapp.com/H1roxLZOkFk1lqXSsa392e",
    },
  };
  const params = useParams();
  const wkName = params.workshop;
  const hasWk = !!wkName && wkName in workshops;
  let wkDetails = { name: "", link: "" };
  if (hasWk) wkDetails = workshops[wkName];
  return (
    <div
      className={[
        styles.parentContainer,
        !hasWk ? styles.invalidParent : null,
      ].join(" ")}
    >
      <div class={styles.container}>
        <h1>
          {hasWk
            ? `Thank you for signing up for UnTaboo's upcoming ${wkDetails.name} workshop.`
            : `You are looking at the thank you page, but without any workshop information.`}
        </h1>
        {hasWk && (
          <p class={styles.subtext}>
            🔥 To receive real-time updates on the workshop, please join our
            official WhatsApp group 🔥
          </p>
        )}
        {hasWk && (
          <a
            href={wkDetails.link}
            class={styles.btn}
            target="_blank"
            rel="noreferrer"
          >
            Join UnTaboo Group 🚀
          </a>
        )}
      </div>
    </div>
  );
};
